function buildMemoryDuplicateNote(memory) {
    const duplicateCount = Number.parseInt(memory?.duplicate_count || 1, 10);

    if (!Number.isFinite(duplicateCount) || duplicateCount <= 1) {
        return '';
    }

    return ` · merges ${duplicateCount} similar memories`;
}

function buildMemoryStatusNote(memory) {
    const statusLabel = String(memory?.status_label || '').trim();

    if (!statusLabel || statusLabel === 'active') {
        return '';
    }

    return ` · ${statusLabel}`;
}

function buildMemoryMoveToGlobalButton(memoryId, memoryScope) {
    const normalizedId = Number.parseInt(memoryId, 10);

    if (memoryScope !== 'chat' || !Number.isFinite(normalizedId) || normalizedId <= 0) {
        return '';
    }

    return `<button type="button" class="chat-settings-memory-menu-item chat-settings-memory-move-global" data-memory-id="${normalizedId}" role="menuitem">Move to global</button>`;
}

function buildMemoryActionsMenu(memoryId, memoryScope) {
    const normalizedId = Number.parseInt(memoryId, 10);

    if (!Number.isFinite(normalizedId) || normalizedId <= 0) {
        return '';
    }

    const menuId = `chat-settings-memory-menu-${normalizedId}`;

    return `<div class="chat-settings-memory-menu">
        <button type="button" class="chat-settings-memory-menu-trigger" aria-label="Memory actions" aria-haspopup="menu" aria-expanded="false" aria-controls="${menuId}">
            <i class="fa-solid fa-ellipsis-vertical" aria-hidden="true"></i>
        </button>
        <div class="chat-settings-memory-menu-list d-none" id="${menuId}" role="menu">
            ${buildMemoryMoveToGlobalButton(normalizedId, memoryScope)}
            <button type="button" class="chat-settings-memory-menu-item chat-settings-memory-edit" data-memory-id="${normalizedId}" role="menuitem">Edit</button>
            <button type="button" class="chat-settings-memory-menu-item chat-settings-memory-delete" data-memory-id="${normalizedId}" role="menuitem">Delete</button>
        </div>
    </div>`;
}

module.exports = {
    buildMemoryDuplicateNote,
    buildMemoryStatusNote,
    buildMemoryMoveToGlobalButton,
    buildMemoryActionsMenu,
};
